export default {
	title: 'Scenari',
	subtitle: 'Elenca tutti gli scenari possibili che valuterai',
	no_description: 'Nessuno scenario',

	context_worse: 'Negativo',
	context_best: 'Positivo',

	tabs: {
		list: 'Lista',
		details: 'Dettagli',
		visualization: 'Visualizzazione',
		alt_title: 'Sintesi'
	}
};
